
export const FETCH_PURITIES_REQUEST = 'FETCH_PURITIES_REQUEST';
export const FETCH_PURITIES_SUCCESS = 'FETCH_PURITIES_SUCCESS';
export const FETCH_PURITIES_FAILURE = 'FETCH_PURITIES_FAILURE';

export const CREATE_PURITY = 'CREATE_PURITY';
export const UPDATE_PURITY = 'UPDATE_PURITY';
export const DELETE_PURITY = 'DELETE_PURITY';
